<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
             <v-slide-x-reverse-transition>
                <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error }}</v-alert>
                <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success }}</v-alert>
            </v-slide-x-reverse-transition>
            <v-row >
                <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12">
                    <div class="title_page ma-3">
                    <h4 class="breadcrumb_title_page">รายการสินค้าที่นำออกจากคลัง</h4>
                    <v-breadcrumbs :items="sub_menu">
                        <template v-slot:divider>
                        <v-icon>mdi-chevron-right</v-icon>
                        </template>
                    </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                    
                </v-col>
            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
                    <section>
                        <v-row>
                            <v-col xs="9" sm="9" md="9" lg="9" xl="9" cols="9"></v-col>
                            <v-col xs="3" sm="3" md="3" lg="3" xl="3" cols="3">
                                <div class="mt-1">
                                    <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </section>

                    <section class="pa-3">
                        <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0" >
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>
                                    <div class="font-16">{{dataDetail.item.product_code == null ? '-' : dataDetail.item.product_code}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{dataDetail.item.product_name == null ? '-' : dataDetail.item.product_name}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{dataDetail.item.quantity}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{dataDetail.item.unit_name}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{formatPrice(parseFloat(dataDetail.item.total))}}</div>
                                </td>
                                <td>
                                    <div class="d-flex">
                                            <span>
                                                <v-btn elevation="2" class="my-3 mx-2 font-16" outlined color="#8EBBDC" title="พิมพ์"
                                                    style="border-radius:10px" @click="$router.push(`exportproductdetail?id=${dataDetail.item.product_id}&unit_id=${dataDetail.item.unit_id}`)">
                                                    <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                                                </v-btn>
                                            </span>                 
                                        </div>
                                </td>
                            </tr>
                        </template>
                        </v-data-table>
                    </section>

                </v-card>
            </div>
        </div>
    </div>
</template>
  
<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
// import Swal from "sweetalert2";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_Recall_Bill",
    data() {
        return {
            loading_page: false,
            delete_all: false,
            dialog_detail: false,
            alert_success: false,
            alert_message_success: null,
            alert_message_error: null,
            search: '',
            footer_Props:{
                'items-per-page-text':'รายการต่อหน้า'
            },
            headers:[
                { 
                    text: 'รหัสสินค้า',
                    value: 'invoice_code',
                    fixed: true,
                    width: '120px'
                },
                { 
                    text: 'ชื่อสินค้า',
                    value: 'receipt_tax',
                    fixed: true,
                    width: '200px'
                },
                { 
                    text: 'จำนวน',
                    value: 'receipt_date',
                    fixed: true,
                    width: '120px'
                },
                { 
                    text: 'หน่วยนับ',
                    value: 'receipt_date',
                    fixed: true,
                    width: '120px'
                },
                { 
                    text: 'มูลค่าสินค้าทิ้ง',
                    value: 'receipt_name',
                    fixed: true,
                    width: '210px'
                },
                { 
                    text: 'จัดการ',
                    value: 'receipt_price',
                    fixed: true,
                    width: '130px'
                },
            ],

            data_list: [],
            sub_menu:[
                {
                    text:'ระบบ POS',
                    disabled:false,
                },
                {
                    text:'คลังสินค้า',
                    disabled:false,
                },
                {
                    text:'รายการสินค้าที่นำออกจากคลัง',
                    disabled:false,
                },
            ],
            detailList: {},
            total_qty: 0,
            total_price: 0
        }
    }, methods: {
        link(link){
            window.location.href = link;
        },
        formatPrice(number){
            return formatPrice(number)
        },
        getExportProductList(){
             let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                HTTP_ARIN.get(`/pos/storage/product/dump`, config).then((res) => {
                    if (res.data.successful === true) {
                        this.data_list = res.data.data;
                    }
                })
        },
    //    async getDetail(id){
    //     this.total_qty = 0
    //     this.total_price = 0
    //         let config = {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
    //                 }
    //             }
    //            await HTTP_ARIN.get(`/pos/storage/product/dump/detail/${id}`, config).then((res) => {
    //                 if (res.data.successful === true) {
    //                     this.detailList = res.data.data
    //                      this.detailList.invoice_list.forEach((detail) => {
    //                       this.total_qty += parseFloat(detail.qty)
    //                       this.total_price += parseFloat(detail.total)
    //                     })
    //                     this.dialog_detail = true
    //                 }
    //             })
    //     },
    },
    mounted(){
       this.getExportProductList()
    }
}
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 200px; */
}
.btn_add_data_pop {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 135px !important;
}
</style>
  